import { render, staticRenderFns } from "./TopSellerUsers.vue?vue&type=template&id=4acbe0ab&"
import script from "./TopSellerUsers.vue?vue&type=script&lang=js&"
export * from "./TopSellerUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports